/** @format */

import React from 'react'

export const Icon = ({ type }) => {
  switch (type) {
    case 'favorite':
      return <div>VVV {type}</div>
    default:
      return <div>{type}</div>
  }
}
